import ImageSlider from './imageSlider'

export default ImageSlider